import { captureException } from '@sentry/nextjs'
import { useAtom } from 'jotai'
import * as React from 'react'
import { rwStreamClientAtom } from '../../../atoms/StreamClient'
import useAuth from '../../../hooks/auth'
import BaseFollowButton from './BaseFollowButton'

// ============================ Styled components ==============================

const FollowButton = ({
  address,
  onUpdate,
}: {
  address: string
  onUpdate: (follow: boolean) => void
}): JSX.Element => {
  const [isFollowing, setIsFollowing] = React.useState<boolean>(false)
  const [isUpdating, setIsUpdating] = React.useState<boolean>(false)
  const [streamClient] = useAtom(rwStreamClientAtom)
  const { profile } = useAuth()

  React.useEffect(() => {
    if (!address || !profile?.address || address === profile.address) {
      return
    }

    ;(async () => {
      try {
        setIsUpdating(true)
        const notificationFeed = streamClient.feed('notifications', profile.address)
        const followingResponse = await notificationFeed.following({
          offset: 0,
          limit: 1,
          filter: [`videos:${address}`],
        })
        setIsFollowing(followingResponse.results.length > 0)
      } catch (err) {
        console.error(err)
        captureException(err)
      } finally {
        setIsUpdating(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, profile?.address])

  return (
    <BaseFollowButton
      address={address}
      isUpdating={isUpdating}
      isFollowing={isFollowing}
      setIsFollowing={setIsFollowing}
      setIsUpdating={setIsUpdating}
      onUpdate={onUpdate}
    />
  )
}

export default FollowButton
